"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateMeetingNoteServiceActionSchema () {
        return CreateMeetingNoteServiceActionSchema;
    },
    get MeetingNoteModel () {
        return MeetingNoteModel;
    },
    get MeetingNoteParticipant () {
        return MeetingNoteParticipant;
    },
    get UpdateMeetingNoteServiceActionSchema () {
        return UpdateMeetingNoteServiceActionSchema;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("./base");
const MeetingNoteParticipant = _zod.z.object({
    userId: _utilsisomorphic.transformObjectId,
    role: _models.MeetingNoteRoleSchema
});
const MeetingNoteModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    meetingId: _utilsisomorphic.transformObjectId,
    content: _zod.z.string(),
    participants: _zod.z.array(MeetingNoteParticipant),
    visibility: _models.MeetingNoteVisibilitySchema,
    updated: _base.UserActionRecord
});
const CreateMeetingNoteServiceActionSchema = _models.MeetingNotesSchema.pick({
    content: true,
    participants: true,
    visibility: true
});
const UpdateMeetingNoteServiceActionSchema = _models.MeetingNotesSchema.pick({
    content: true
});
